import { Component, ReactNode } from 'react';

type Props = {
	fallback: ReactNode;
	children: ReactNode;
};

type States = {
	hasError: boolean;
};

export class ErrorBoundary extends Component<Props, States> {
	constructor(props: Props) {
		super(props);

		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback;
		}

		return this.props.children;
	}
}
